import gsap from "gsap";

export function messageAnimation1() {
  let currentAnimation = null;

  // **初回アニメーション実行**
  setupAnimation();

  // **リサイズ時にアニメーションをリセット & 再適用**
  window.addEventListener("resize", () => {
    resetAnimation();
    setupAnimation();
  });

  function resetAnimation() {
    if (currentAnimation) {
      currentAnimation.kill();
      currentAnimation = null;
    }
    // **要素の位置・スタイルを完全リセット**
    gsap.set(".parts-member1", { x: 0, y: 0, rotation: 0, clearProps: "all" });
  }

  function setupAnimation() {
    resetAnimation();

    const isPC = window.matchMedia("(min-width: 750px)").matches;
    const members = [...document.querySelectorAll(".parts-member1")]; // **全メンバーを配列で取得**

    if (members.length === 0) return;

    currentAnimation = isPC ? animateMembersPC(members) : animateMembersSP(members);
  }

  // **PC用アニメーション**
  function animateMembersPC(members) {
    return createAnimation(members, [
      { duration: 8, rotation: "-=1440", delay: 0 },
      { duration: 10, rotation: "-=1440", delay: 0.7 },
    ]);
  }

  // **SP用アニメーション**
  function animateMembersSP(members) {
    return createAnimation(members, [
      { duration: 6, rotation: "-=1440", delay: 0 },
      { duration: 7, rotation: "-=1440", delay: 0.8 },
    ]);
  }

  // **共通アニメーション関数（PC / SP 両方で使用）**
  function createAnimation(members, animations) {
    const containerWidth = document.querySelector(".message-animation").offsetWidth;
    const partWidth = members[0].offsetWidth;

    const tl = gsap.timeline({ repeat: -1, repeatDelay: 1 });

    // **初期位置を一括適用**
    tl.set(members, { x: 0, y: 0, rotation: 0 });

    // **各メンバーのアニメーション**
    members.forEach((member, index) => {
      const { duration, rotation, delay } = animations[index] || animations[0];
      tl.to(
        member,
        {
          x: -containerWidth - partWidth,
          duration: duration,
          rotation: rotation,
          ease: "linear",
        },
        `<+=${delay}`
      );
    });

    return tl;
  }
}
